import type { TargetableInventoryList } from '@openx/types/targeting/inventoryAndContent';

export const isInvList = (option: unknown[]): option is TargetableInventoryList[] => {
  if (!Array.isArray(option) || option.length === 0) {
    return false;
  }

  return option.some(item => {
    const isArray = Array.isArray(item);
    const hasData = isArray && item.length > 0;
    const hasId = hasData && 'id' in item[0];

    return isArray && hasData && hasId;
  });
};
